import React from "react";
import { Link, useNavigate } from 'react-router-dom';
import "./Footer.css";

// Import do logo e ícones sociais
import logoAmbar from "../../assets/img/logo_ambar_v2.png";
import iconFacebook from "../../assets/img/facebook.svg";
import iconInstagram from "../../assets/img/instagram.svg";
import iconLinkedin from "../../assets/img/linkedin.svg";
import iconYoutube from "../../assets/img/youtube.svg";

export default function Footer() {

    const navigate = useNavigate();

  const goToSection = (id) => {
    navigate("/", { state: { scrollTo: id } });
  };

  return (
    <footer className="footer-wrapper py-5">
  <div className="container">
    <div className="row footer-row">
      {/* Logo e descrição */}
      <div className="col-12 col-md-auto mb-4 mb-md-0 text-center text-md-start scroll-reveal-zoom">
        <img src={logoAmbar} alt="Âmbar" className="footer-logo mb-3" />
        <p className="footer-text">
          Conectamos inovação, engenharia<br/> e meio ambiente.<br/> Oferecemos
          soluções sustentáveis<br/> para um mundo complexo.
        </p>
        <div className="social-icons d-flex justify-content-center justify-content-md-start gap-3 mt-3">
          <a href="https://www.facebook.com/share/17TPg9C4LQ" target="_blank" rel="noopener noreferrer">
            <img src={iconFacebook} alt="Facebook" />
          </a>
          <a href="https://instagram.com/ambar_meioambiente" target="_blank" rel="noopener noreferrer">
            <img src={iconInstagram} alt="Instagram" />
          </a>
          <a href="https://br.linkedin.com/company/%C3%A2mbar-solu%C3%A7%C3%B5es-em-engenharia-e-meio-ambiente" target="_blank" rel="noopener noreferrer">
            <img src={iconLinkedin} alt="LinkedIn" />
          </a>
          <a href="https://www.youtube.com/@%C3%82mbarSolu%C3%A7%C3%B5es-b2d" target="_blank" rel="noopener noreferrer">
            <img src={iconYoutube} alt="YouTube" />
          </a>
        </div>
      </div>

      {/* Serviços (rotas/páginas) */}
      <div className="col-12 col-md-auto mb-4 mb-md-0 text-center text-md-start scroll-reveal-zoom">
        <h5 className="footer-titulo">Serviços</h5>
        <ul className="footer-list">
          <li><Link to="/servicos/capacitacao-e-treinamento-ambiental">Capacitação e Treinamento</Link></li>
          <li><Link to="/servicos/estudos-e-regularizacao-ambiental">Estudos e Regularização</Link></li>
          <li><Link to="/servicos/gestao-estrategica-em-esg">Gestão Estratégica em ESG</Link></li>
          <li><Link to="/servicos/consultoria-monitoramento-e-gestao-ambiental">Gestão e Monitoramento</Link></li>
          <li><Link to="/servicos/engenharia-aplicada-e-projetos-tecnicos">Projetos de Engenharia</Link></li>
          <li><Link to="/servicos/seguranca-do-trabalho">Segurança do Trabalho</Link></li>
        </ul>
      </div>

      {/* Links rápidos (âncoras internas) */}
      <div className="col-12 col-md-auto text-center text-md-start scroll-reveal-zoom">
        <h5 className="footer-titulo">Links Rápidos</h5>
        <ul className="footer-list">
          <li><a href="/">Home</a></li>
          <li><a onClick={() => goToSection("servicos")}>Serviços</a></li>
          <li><a onClick={() => goToSection("clientes")}>Clientes</a></li>
          <li><a onClick={() => goToSection("equipe")}>Nosso Time</a></li>
          <li><a onClick={() => goToSection("projetos")}>Projetos</a></li>
        </ul>
      </div>
    </div>

    {/* Rodapé final */}
    <div className="footer-bottom text-center mt-5 text-uppercase scroll-reveal-glass">
      <hr className="footer-line" />
      <div className="footer-bottom">
        <div className="footer-info">
          <div>
            <p className="direitos">
              © {new Date().getFullYear()} ÂMBAR. TODOS OS DIREITOS RESERVADOS.
            </p>
          </div>
          <div>
            <p className="dev">
              Desenvolvido por{" "}
              <a href="https://casoftwares.com.br" target="_blank" rel="noopener noreferrer">
                <ins>CA Softwares</ins>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>

  );
}
